import React from 'react';
import TeamDetailsModuleProps from './type';
import TeamDetails from '../../components/TeamDetails';
import RidersAccordion from '../../components/RidersAccordion';
import './styles.scss';

const TeamDetailsModule = ({
  details,
  riders,
}: TeamDetailsModuleProps) => (
  <div className="team-details-module page-template">
    {details && <TeamDetails {...details} />}
    {riders && <RidersAccordion {...riders} />}
  </div>
);

export default TeamDetailsModule;
